import { ChangeDetectionStrategy, Component, computed, inject } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';

import { Store } from '@ngrx/store';

import { selectChatState, selectUser } from '../../../../store/app.selectors';

import { BaseComponent } from '../../../shared/components/base/base.component';
import { ImagesService } from '../../../shared/services/images.service';
import { IUserProfile } from '../../../user/interfaces/IUserProfile';
import { AppStateWithChat, chatInitialState } from '../../store/chat.reducer';

@Component({
  selector: 'ngx-channel-blank',
  templateUrl: './channel-blank.component.html',
  styleUrls: ['./channel-blank.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class ChannelBlankComponent extends BaseComponent {
  private store = inject(Store<AppStateWithChat>);
  public imagesService = inject(ImagesService);

  chat = toSignal(this.store.select(selectChatState), { initialValue: chatInitialState });
  profileInfo = toSignal(this.store.select(selectUser), { initialValue: null as IUserProfile | null });
  selectedChannel = computed(() => this.chat().selectedChannel);
}
